import "./App.css";
import Homepage from "./pages/Homepage";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./styles/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EntryPage from "./pages/EntryPage";
import { useEffect } from "react";
import RegisterUser from "./pages/RegisterUser";
import UsersList from "./pages/users/UsersList";
import LoginPage from "./pages/LoginPage";
import NotFound from "./pages/NotFound";
import { Authentication } from "./useAuth";
import UserRoles from "./pages/UserRoles";
import { ProfilePage } from "./pages/ProfilePage";
import AddNewDoc from "./pages/documentations/AddNewDoc";
import DocsList from "./pages/documentations/DocsList";
import Doc from "./pages/documentations/Doc";
import EditDoc from "./pages/documentations/EditDoc";
import CategoryManager from "./pages/documentations/CategoryManager";
import RegisterProject from "./pages/projects/RegisterProject";
import ProjectsList from "./pages/projects/ProjectsList";
import ProjectDetails from "./pages/projects/ProjectDetails";
import EditProject from "./pages/projects/EditProject";
import RegisterEmployee from "./pages/projects/RegisterEmployee";
import EmployeesList from "./pages/projects/EmployeesList";
import AddProjectUpdate from "./pages/projects/AddProjectUpdate";
import RegisterDomain from "./pages/projects/RegisterDomain";
import DomainsList from "./pages/projects/DomainsList";
import BackupDashboard from "./pages/backups/BackupDashboard";
import BackupLogsList from "./pages/backups/BackupLogsList";

function App() {
  const Scroll = (props) => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    return props.children;
  };
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" />
      <Authentication>
        <Scroll>
          <Routes>
            <Route path="login" element={<LoginPage />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/" element={<Navigate to="/my" />} />
            <Route path="/my" element={<EntryPage />}>
              <Route path="" element={<Navigate to="home" />} />
              <Route path="home" element={<Homepage />} />

              {/* Projects */}
              <Route path="registerProject" element={<RegisterProject />} />
              <Route path="projectsList" element={<ProjectsList />} />
              <Route path="projectDetails" element={<ProjectDetails />} />
              <Route path="editProject" element={<EditProject />} />
              <Route path="addProjectUpdate" element={<AddProjectUpdate />} />

              {/* Domain */}
              <Route path="registerDomain" element={<RegisterDomain />} />
              <Route path="domainsList" element={<DomainsList />} />

              {/* Employees */}
              <Route path="registerEmployee" element={<RegisterEmployee />} />
              <Route path="employeesList" element={<EmployeesList />} />

              {/* Documents */}
              <Route path="addNewDoc" element={<AddNewDoc />} />
              <Route path="docsList" element={<DocsList />} />
              <Route path="categoryManager" element={<CategoryManager />} />
              {/* Users */}
              <Route path="usersList" element={<UsersList />} />
              <Route path="registerUser" element={<RegisterUser />} />
              <Route path="userRoles" element={<UserRoles />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="doc" element={<Doc />} />
              {/* Backups & Security */}
              <Route path="backupDashboard" element={<BackupDashboard />} />
              <Route path="backupLogsList" element={<BackupLogsList />} />
            </Route>
          </Routes>
        </Scroll>
      </Authentication>
    </BrowserRouter>
  );
}

export default App;
